import { create } from 'zustand';

export type LiveNotif = { id: string; type: string; message: string; when: number };

type NotifState = {
  items: LiveNotif[];
  unread: number;
  push: (n: Omit<LiveNotif, 'id' | 'when'>) => void;
  markAllRead: () => void;
  clear: () => void;
};

let counter = 0;

export const useNotificationsStore = create<NotifState>((set, get) => ({
  items: [],
  unread: 0,
  push: (n) => {
    counter += 1;
    set({
      items: [{ id: `n${counter}`, when: Date.now(), ...n }, ...get().items].slice(0, 50),
      unread: get().unread + 1,
    });
  },
  markAllRead: () => set({ unread: 0 }),
  clear: () => set({ items: [], unread: 0 }),
}));
